import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
import AlgoliaResultsCount from './AlgoliaResultsCount';
const ProductListingResultsCountWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="text-sm text-gray-light2 md:relative md:self-center">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const ProductListingResultsCount = t0 => {
  const $ = _c(4);
  const {
    loading: t1,
    totalProductCount,
    variant
  } = t0;
  const loading = t1 === undefined ? false : t1;
  if (variant === "advanced-search") {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProductListingResultsCountWrapper><AlgoliaResultsCount suffix=" Results" /></ProductListingResultsCountWrapper>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (loading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <TextPlaceholder className="!w-[75px] !h-[15px]" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isNil(totalProductCount)) {
    return null;
  }
  const t2 = `${totalProductCount} Results`;
  let t3;
  if ($[2] !== t2) {
    t3 = <ProductListingResultsCountWrapper>{t2}</ProductListingResultsCountWrapper>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
ProductListingResultsCount.propTypes = {
  loading: PropTypes.bool,
  totalProductCount: PropTypes.number
};
export default ProductListingResultsCount;